// TrendingStyles.jsx - Consumer Fun Layer (without alienating pros)
import React from 'react';
import './TrendingStyles.css';
import landingData from '../data/landingData.json';
import { AnimationVariant, BeforeAfterPreview } from '../../homeScreen/components/BeforeAfterPreview';
import SimpleBeforeAfter from '../../homeScreen/components/SimpleBeforeAfter';

const TrendingStyles = () => {
  const { trendingStyles } = landingData;
  const handleTryTrend = () => {
    window.location.href = 'https://account.fluxuro.ai';
  };

  return (
    <section className="landing-section trending-section">
      <h2 className="section-title">Always on trend</h2>
      <p className="section-subtitle">
        Trending styles, seasonal looks, viral transformations.
      </p>

      <div className="trending-grid">
        {trendingStyles.map((style, index) => (
          <div key={index} className="trending-card" onClick={handleTryTrend}>
            <SimpleBeforeAfter
              before={style.beforeImage}
              after={style.afterImage}
              animationVariant={AnimationVariant.SLIDE}
              randomize
              className="trending-preview"
            />
            <span className="trending-label">{style.name}</span>
          </div>
        ))}
      </div>

      <button className="btn-secondary trending-cta" onClick={handleTryTrend}>
        Explore 100+ more
      </button>
    </section>
  );
};

export default TrendingStyles;
